// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /notification-settings/get-pool.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeNotificationSettingsGetPoolBody,
  typeNotificationSettingsGetPoolOutput200,
} from "../../sdk/notificationSettings/postNotificationSettingsGetPool";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildNotificationSettingsGetPoolQueryKey(
  payload: typeNotificationSettingsGetPoolBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  return [
    "post:notificationSettings:notificationSettingsGetPool",
    "svc:notification-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeNotificationSettingsGetPoolOutput200,
    unknown,
    typeNotificationSettingsGetPoolOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useNotificationSettingsGetPool(
  payload: typeNotificationSettingsGetPoolBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildNotificationSettingsGetPoolQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postNotificationSettingsGetPool(payload),
    ...resolvedOptions,
  });
}
